import React, { useState, useEffect } from 'react';
import instruments from '../data/instruments.json';

interface Tuning {
  name: string;
  notes: string[];
  description: string;
}

export interface Instrument {
  name: string;
  tunings: Tuning[];
  defaultTuning: string;
  hasDroneString?: boolean;
  droneStringStartingFret?: number;
  hideDroneStringNotes?: boolean;
}

interface InstrumentSelectorProps {
  selectedInstrument: string;
  setSelectedInstrument: (instrument: string) => void;
  setTuning: (tuning: string) => void;
  setHasDroneString: (hasDroneString: boolean) => void;
  setDroneStringStartingFret: (droneStringStartingFret: number) => void;
  setHideDroneStringNotes: (hideDroneStringNotes: boolean) => void;
  isLeftHanded: boolean;
  setIsLeftHanded: (isLeftHanded: boolean) => void;
}

const InstrumentSelector: React.FC<InstrumentSelectorProps> = ({
  selectedInstrument, 
  setSelectedInstrument, 
  setTuning, 
  setHasDroneString, 
  setDroneStringStartingFret, 
  setHideDroneStringNotes,
  isLeftHanded, 
  setIsLeftHanded 
}) => {
  const [instrument, setInstrument] = useState<Instrument | null>(null);

  useEffect(() => {
    const selected = instruments.find(inst => inst.name === selectedInstrument);
    setInstrument(selected || null);
  }, [selectedInstrument]);

  useEffect(() => {
    if (instrument) {
      const lastTuning = localStorage.getItem(`${instrument.name}_lastTuning`);
      const defaultTuning = instrument.defaultTuning;
      const tuningToSet = lastTuning || defaultTuning;
      setTuning(tuningToSet);
      setHasDroneString(!!instrument.hasDroneString);
      setDroneStringStartingFret(instrument.droneStringStartingFret || 0);
      setHideDroneStringNotes(!!instrument.hideDroneStringNotes);
    }
  }, [instrument, setTuning, setHasDroneString, setDroneStringStartingFret]);

  const handleInstrumentChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newInstrument = e.target.value;
    setSelectedInstrument(newInstrument);
    const selected = instruments.find(inst => inst.name === newInstrument);
    if (selected) {
      const lastTuning = localStorage.getItem(`${newInstrument}_lastTuning`);
      const tuningToSet = lastTuning || selected.defaultTuning;
      setTuning(tuningToSet);
    }
  };

  return (
    <div className="form-control">
      <label className="label">
        <span className="label-text">Instrument:</span>
      </label>
      <select 
        className="select select-bordered w-full"
        value={selectedInstrument}
        onChange={handleInstrumentChange}
      >
        {instruments.map((inst, index) => (
          <option key={index} value={inst.name}>{inst.name}</option>
        ))}
      </select>
      
    </div>
  );
};

export default InstrumentSelector;